import Flex from 'typescript-styled-flex'
import styled, { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const TagWrapper = styled(Flex as any)<IWithSize>`
  background-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
  flex-direction: row;
  border-radius: 3px;
  padding: ${({ size }) =>
    size ? `${14 * size}px ${12 * size}px` : '14px 12px'};
  margin-bottom: ${({ size }) => (size ? 10 * size : 10)}px;
  margin-right: ${({ size }) => (size ? 8 * size : 8)}px;
  color: white;
  font-weight: bold;
  max-width: 100%;
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;
`

export default TagWrapper
